import api from '@/api';
import moment from 'moment';

const state = {
  projectsPullRequests: [],
  usersPullRequests: [],
  loadedProject: null,
  loadedUser: null,
};

const getters = {
  projectPullRequests: state => state.projectsPullRequests
    .find(project => project.projectName === state.loadedProject),
};

const actions = {
  async getListByProject({ state, commit, rootGetters }, payload) {
    if (state.loadedUser === payload.user && state.projectsPullRequests.length > 0) {
      return;
    }

    commit('projectsPullRequests', []);
    commit('loadedUser', payload.user);
    const user = rootGetters['users/getUserById'](state.loadedUser);
    const response = await api.post('PullRequests/List', {
      Member: user,
      StartDate: payload.startDate,
      EndDate: payload.endDate,
    });

    commit('projectsPullRequests', response.data.projectPullRequests);
  },

  async exportToExcel({ state, rootGetters }) {
    const user = rootGetters['users/getUserById'](state.loadedUser);
    const response = await api.post('Reports/ExportPullRequestReportToExcel', {
      projectPullRequests: state.projectsPullRequests,
      name: user.user.displayName,
    }, { responseType: 'blob' });

    const url = window.URL.createObjectURL(new Blob([response.data]));
    const link = document.createElement('a');
    link.href = url;
    link.setAttribute('download', `PullRequests_${user.user.displayName}_${moment().format('YYYY-MM-DD')}.xlsx`);
    document.body.appendChild(link);
    link.click();
  },

  async getAllPullRequest({ commit, rootState }, payload) {
    const response = await api.post('PullRequests/All', {
      StartDate: payload.startDate,
      EndDate: payload.endDate,
      Users: rootState.users.users,
    });

    commit('usersPullRequests', response.data);
  },
};

const mutations = {
  projectsPullRequests(state, payload) {
    state.projectsPullRequests = payload;
  },
  usersPullRequests(state, payload) {
    state.usersPullRequests = payload;
  },
  loadedUser(state, payload) {
    state.loadedUser = payload;
  },
  loadedProject(state, payload) {
    state.loadedProject = payload;
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
